import { positionMap } from '../../../mappers.mappings.js';

var positionStyleMapper = {
  position: function position(value, _) {
    return {
      classNames: [positionMap[value]]
    };
  },
  top: function top(value, _) {
    return {
      style: {
        top: value
      }
    };
  },
  bottom: function bottom(value, _) {
    return {
      style: {
        bottom: value
      }
    };
  },
  start: function start(value, context) {
    var start = context.isLtr ? {
      left: value
    } : {
      right: value
    };
    return {
      style: start
    };
  },
  end: function end(value, context) {
    var end = context.isLtr ? {
      right: value
    } : {
      left: value
    };
    return {
      style: end
    };
  },
  zIndex: function zIndex(value, _) {
    return {
      style: {
        zIndex: value
      }
    };
  }
};

export { positionStyleMapper };
//# sourceMappingURL=position.js.map
